class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function updateFreeShippingBar(cart) {
    var freeShippingThreshold = 175; // Free shipping minimum
    var cartTotal = cart.total_price / 100; // Convert Shopify's price format from cents to dollars
    var remainingAmount = freeShippingThreshold - cartTotal;
    var progressBar = document.querySelector(".cart-shipping-progress-bar");
    var shippingMessage = document.querySelector(".cart-shipping-message");

    if (!progressBar || !shippingMessage) return; // Prevents errors if elements don't exist

    // Update progress bar width
    var progress = (cartTotal / freeShippingThreshold) * 100;
    progressBar.style.width = Math.min(progress, 100) + "%";

    // Update the shipping message
    if (remainingAmount > 0) {
        shippingMessage.innerHTML = `You are <strong>$${remainingAmount.toFixed(2)} USD</strong> away from FREE Shipping!`;
    } else {
        shippingMessage.innerHTML = `<strong>How DIVINE!</strong> You qualify for FREE Shipping.`;
    }
}

// Function to fetch the latest cart data and update the free shipping bar
function fetchCartAndUpdate() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => updateFreeShippingBar(cart));
}

// Run on page load
document.addEventListener("DOMContentLoaded", fetchCartAndUpdate);

// Run every time an item is added or removed
document.addEventListener("cart:updated", fetchCartAndUpdate);

function fixCheckoutButton() {
    var checkoutButton = document.querySelector("#CartDrawer-Checkout");
    if (checkoutButton) {
        checkoutButton.style.width = "100%";
        checkoutButton.style.maxWidth = "100%";
        checkoutButton.style.display = "block";
        checkoutButton.style.textAlign = "center";
        checkoutButton.style.padding = "15px 0";
    }
}

// Run the fix when the cart updates
document.addEventListener("cart:updated", fixCheckoutButton);
document.addEventListener("DOMContentLoaded", fixCheckoutButton);
